import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiVersions } from './api-version';
import { BaseService } from './base.service';
import { WidgetModel } from '../models/widget.model';

@Injectable({
  providedIn: 'root',
})
export class WidgetsService extends BaseService {
  private baseUrl = 'widgets';
  private _homepageWidgets: WidgetModel[] = [];
  public readonly homepageWidgets = new BehaviorSubject<WidgetModel[]>(null);
  constructor() {
    super();
  }

  public getHomePageWidgets() {
    let path = `${this.baseUrl}/homepage`;
    this.get<WidgetModel[]>(path, true, ApiVersions.unversioned).subscribe((result) => {
      this._homepageWidgets = result;
      this.homepageWidgets.next(this._homepageWidgets);
    });
  }

  public addOrUpdateHomePageWidgets(model: WidgetModel) {
    let path = `${this.baseUrl}/homepage`;
    this.post(path, model, null, ApiVersions.unversioned).subscribe((result: WidgetModel) => {
      const index = this._homepageWidgets.findIndex((x) => x.widgetUIType == result.widgetUIType);
      if (index != -1) {
        this._homepageWidgets[index].selecedViewId = result.selecedViewId;
      } else {
        this._homepageWidgets.push(result);
      }
    });
  }
}
